if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('.js-split-div .js-split-span.is-normal');
        this.submitButtonTextHover = this.submitButton.querySelector('.js-split-div .js-split-span.is-hoverd');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      reapplySplit() {
        setTimeout(() => {
          $('.js-split-span').each(function () {
            let $this = $(this);
            let text = $this.text(); // タグを除いたテキストを取得
            let spanText = '';
            let lastIndex = 0;
            text.split('').forEach(function (v, i) {
              let space = '';
              if (v === ' ') {
                space = 'is-space';
                if ($this.hasClass('split-br')) {
                  space = 'is-br';
                }
                if ($this.hasClass('split-br-sp')) {
                  space = 'is-br-sp';
                }
              }
              if ($this.hasClass('is-random')) {
                i = Math.random() * 8 + 1.5;
              }
              spanText += `<span style="--char-index:${i}" class="${space}">${v}</span>`;
              lastIndex = i;
            });
            $this.html(spanText);
            if ($this.next('svg').length) {
              $this.next('svg').css({ '--char-index': lastIndex + 1 });
            }
          });
        }, 100);
      }

      // 変更イベントのバインディングを再適用する関数
      reapplySetChangeSelectLabel() {
        // 既存のバインディングを解除（念のため）
        $(document).off('change', '.page-item-detail__main-variants select');
        // 新たにバインディングする
        $(document).on('change', '.page-item-detail__main-variants select', function () {
          setTimeout(() => {
            let $select = $(this);
            const $parent = $select.closest('.page-item-detail__main-variant');
            const $label = $parent.find('.page-item-detail__main-variant-select-label');
            // console.log($select.find('> option:selected').text());
            $label.text($select.find('> option:selected').text());
          }, 200);
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        // this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        this.appendEasifyOptionProperties(formData);
        if (this.cart) {
          // formData.append(
          //   'sections',
          //   this.cart.getSectionsToRender().map((section) => section.id)
          // );
          // formData.append('sections_url', window.location.pathname);
          // this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              // this.cart.renderContents(response);
              const notification = document.getElementById('cart-notification');
              if (notification) {
                notification.classList.add('active');
                const modalTitle = notification.querySelector(
                  '.page-item-detail__modaldiscription-title'
                );
                if (modalTitle) {
                  modalTitle.textContent = 'ショッピングカートに追加されました';
                }
              }
            }
            this.reapplySplit();
            this.reapplySetChangeSelectLabel();
          })
          .catch((e) => {
            console.error(e);
            const notification = document.getElementById('cart-notification');
            if (notification) {
              notification.classList.add('active');
              const modalTitle = notification.querySelector(
                '.page-item-detail__modaldiscription-title'
              );
              if (modalTitle) {
                modalTitle.textContent = 'カートに追加できませんでした。';
              }
            }
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            // this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      // Easify Options は form 外に描画されるため、properties を明示的に載せる
      appendEasifyOptionProperties(formData) {
        const root = document.querySelector('.easify');
        if (!root || !formData) return;

        root
          .querySelectorAll(
            'input[name^="properties["], textarea[name^="properties["], select[name^="properties["]'
          )
          .forEach((el) => {
            if (el.disabled) return;
            if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
            formData.set(el.name, el.value ?? '');
          });

        // 刻印文字など、表示用 input に name が付いていないケースを補完
        root.querySelectorAll('.po-textBox-root').forEach((box) => {
          const input = box.querySelector('.po-textField-input, textarea');
          if (!input || input.name) return;
          const label = box.querySelector('.po-label-label')?.textContent?.trim();
          if (!label) return;
          formData.set(`properties[${label}]`, input.value ?? '');
        });
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) {
            this.submitButtonText.textContent = text;
            this.submitButtonTextHover.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
        this.reapplySplit();
        this.reapplySetChangeSelectLabel();
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
